import * as _ from 'lodash';
import { Component, Injector } from '@angular/core';
import { FilterByComponent } from '../abstract-filter-by.component';

@Component({
    selector: 'filters-by-title',
    templateUrl: './filters-by-title.component.html',
    styleUrls: ['./filters-by-title.component.scss']
})
export class FiltersByTitleComponent extends FilterByComponent {
    public title = '';

    private _timer: any;

    constructor(
        protected injector: Injector
    ) {
        super(injector);
        this.filterKey = 'title';
    }

    clearTimer() {
        if (this._timer) {
            clearTimeout(this._timer);
        }
    }

    onChange() {
        this.clearTimer();
        const value = this[this.filterKey];
        if (value === '') {
            const filters = this.serviceListings.filters;
            delete filters.title;
            this.serviceListings.filters = filters;
            this.isFiltersDirty.emit({ filterKey: this.filterKey, isDirty: false });
        } else {
            this.serviceListings.filters = _.extend(this.serviceListings.filters, {
                title: value
            });
            this.checkIsDirty(value, this.filterKey);
        }
        this._timer = setTimeout(this.sendFilter.bind(this), 700);
    }

    sendFilter() {
        this.serviceListings.dataStoreChanged();
        this.saveFilter();
    }

    reset() {
        this.title = '';
        const filters = this.serviceListings.filters;
        delete filters[this.filterKey];
        this.serviceListings.filters = filters;
        this.isFiltersDirty.emit({ filterKey: this.filterKey, isDirty: false });
    }
}
